import { useDispatch } from 'react-redux';
import BackButton from '../../../../../../components/shared/BackButton';
import { changePage } from '../../../../../../store/Routing/purchaseRouting';
import { Box, Typography, useMediaQuery } from '@mui/material';
import {
  ArrowRightAltIcon,
  ChevronRightIcon,
} from '../../../../../../assets/Icons';

const FinanceBackButton = () => {
  const dispatch = useDispatch();
  const handleBackButton = () => {
    dispatch(changePage('request'));
  };
  const desktopMode = useMediaQuery('(min-width:832px)');

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <BackButton handleClick={handleBackButton} />
        <Box>
          <Typography
            sx={{ fontSize: desktopMode ? '24px' : '14px', fontWeight: '600' }}
          >
            Purchase Request Detail
          </Typography>
          <Box
            sx={{
              display: 'flex',
              color: '#9E9D9D',

              alignItems: 'center',
              mt: '4px',
              gap: 1,
            }}
          >
            <Typography
              sx={{
                fontSize: desktopMode ? '16px' : '12px',
                fontWeight: '100',
              }}
            >
              Subsidiary
            </Typography>
            <ArrowRightAltIcon sx={{ fontSize: '16px' }} />
            <Typography
              sx={{
                fontSize: desktopMode ? '16px' : '12px',
                fontWeight: '100',
              }}
            >
              Hub Name
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default FinanceBackButton;
